
import { Base } from '../base-component';

import './search.component.scss';

import * as $ from 'jquery';

export class Search extends Base {

	lastSearch: string = '';
	searchPageUrl: string;
	jsonFileUrl: string = '';
	notFoundText: string = '';

	constructor(element: Element){
		super(element);
	}

	init() {
		let notFoundData = $(this.element).data('notfound');
		if (notFoundData && notFoundData !== "") {
			this.notFoundText = notFoundData;
		} else {
			this.notFoundText = "No results found for:";
		}		
		let jsonFileData = $(this.element).data('jsonfile');
		if (jsonFileData && jsonFileData !== "") {
			this.jsonFileUrl = jsonFileData;
		} else {
			// this.jsonFileUrl = "/static_file/SBG/conf/search/search__terms.json";
			this.jsonFileUrl = "/file_source/mock/search__dummy.json";
		}
	}

	bindEvents() {

		let jsonUrl = this.jsonFileUrl;

		$('.search__wrapper .icon[data-icon="icon-close"]').click((e) => {

			e.stopImmediatePropagation();

			$('.search__wrapper-input').val('');

			this.closeResults();

		});

		$('.header__secondary-bar-search').click(() => {

			$('.search').addClass('search--opening');
			$('.search').addClass('search--open');

			this.expandSearch();

		});

		$(".search__wrapper-input").keydown(function (e) {

			if (e.keyCode === 13) {
				$('.icon[data-icon="icon-search-blue"]').click();
			} else {
				$('.icon[data-icon="icon-search-blue"]').change();
			}

		});

		$('.icon[data-icon="icon-search-blue"]').change(this.debounce(() => {

			this.lastSearch = ($('.search__wrapper-input').val() as string).toLowerCase();

			$('.search__results-content > a').remove();

			if (this.lastSearch.length < 4) {

				if ($('.search__results').hasClass('search__results--open')) {
					$('.search__results').addClass('search__results--closing');
				}

			}

			if (this.lastSearch.length >= 4) {

				$('.search__results-busy').show();
				$('.search__results').addClass('search__results--open').removeClass('search__results--closing');

				this.http.get(jsonUrl).then((response) => {

					let docfragment = document.createDocumentFragment();

					let filter = response.data.filter((item) => {

						return item.searchCriteria.toLowerCase().indexOf(this.lastSearch) > -1;

					}).sort((a, b) => {

						return a.weight - b.weight;

					});

					if (filter.length === 0) {

						$('.search__results-busy').hide();

						if ($('.search__results').hasClass('search__results--open')) {
							$('.search__results').addClass('search__results--closing');
						}

					} else {

						filter.forEach((element, index) => {

							if (index >= 5)
								return;
							let target = '';
							if (this.validURL(element.relatedPage)) {
								target = 'target="_blank"';
							}
							docfragment.appendChild(document.createRange()
								.createContextualFragment(`
									<a href="${element.relatedPage}" class="search__results-link" ${target}>
										${element.searchCriteria}
									</a>
								`));

						});

						$('.search__results-busy').hide();
						$('.search__results-content')[0].appendChild(docfragment);

					}

				});

			}

		}, 200, false));

		$('.icon[data-icon="icon-search-blue"]').click(() => {
			this.closeResults();
			$('form.search__wrapper').submit();
		});

		window.addEventListener('resize', this.debounce(() => {

			if ($('.search').hasClass('search--open')) {
				this.expandSearch();
			}

		}, 50, false));

	}

	debounce(func, wait, immediate) {

		let timeout;

		return function() {

			let context = this, args = arguments;

			let later = function() {

				timeout = null;

				if (!immediate) func.apply(context, args);

			};

			let callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);

		};

	};

	closeResults() {

		$('.search__results').addClass('search__results--closing');

		setTimeout(() => {

			$('.search').show();
			$('.search__wrapper').width(0);
			$('.search').addClass('search--closing');

			setTimeout(() => {

				$('.search').removeClass('search--open').removeClass('search--closing');
				$('.search__results').removeClass('search__results--open').removeClass('search__results--closing');

			}, 350);

		}, 200);

	}

	expandSearch() {

		let windowWidth = $(window).width();

		if (windowWidth < 768) {

			$('.search__wrapper').css('right', `0px`);
			$('.search__wrapper').width(windowWidth);
			$('.search__results').width(windowWidth - 60);

			setTimeout(() => {
				$('.search').removeClass('search--opening');
			}, 350)

		} else {

			let left = $('.header__secondary-bar-login').offset().left;
			let rightPos = windowWidth - left;
			let searchWidth = this.calculateAvailableWidth();

			$('.search__wrapper').css('right', `${rightPos}px`);
			$('.search__wrapper').width(searchWidth);
			$('.search__results').width(searchWidth - 60);

			setTimeout(() => {
				$('.search').removeClass('search--opening');
			}, 350)

		}

		$('input.search__wrapper-input').focus();

	}

	calculateAvailableWidth() {

		let windowWidth = $(window).width();
		let right = windowWidth - $('.header__secondary-bar-login').offset().left;
		let left = $('.header__secondary-bar-left').offset().left + $('.header__secondary-bar-left').width();

		if (left < 250) {
			left = 250;
		}

		return windowWidth - (right + left);

	}

	validURL(str) {
		const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
		if (pattern.test(str)) {
			return true;
		}
		return false;
	}

}



// WEBPACK FOOTER //
// ./components/search/search.component.ts